'use strict';
define(['../../../../lib/domQ'], function (domQ) {

    function Lazyload() {
    }

    Lazyload.prototype.bind = function () {
        this.imageList = document.querySelectorAll('#common-hdr-main img[data-original]');

        for (var iImage = 0; iImage < this.imageList.length; iImage++) {
            var image = this.imageList[iImage];
            domQ(image).addClass('loader');
            domQ(image.parentNode).addClass('loader__spinner--image');
        }
    };
    Lazyload.prototype.load = function () {
        var _this = this;
        for (var iImage = 0; iImage < this.imageList.length; iImage++) {
            var image = this.imageList[iImage];
            if (image.attributes['data-original'] && _this.isImageVisible(image)) {
                _this.bindEvents(image);
            }
        }
    };
    Lazyload.prototype.bindEvents = function (image) {
        image.addEventListener('load', function () {
            domQ(this.parentNode).removeClass('loader__spinner--image');
            this.removeEventListener('load', this);
        });
        image.src = image.attributes['data-original'].value;
    };
    Lazyload.prototype.isImageVisible = function (image) {
        var boundingRect = image.getBoundingClientRect();
        return (boundingRect.top > 0
        && boundingRect.left >= 0
        && boundingRect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        && boundingRect.right <= (window.innerWidth || document.documentElement.clientWidth));
    };

    return Lazyload;
});



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/navigation/LazyLoad.js